import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f1fa656"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28.414 22.828"
}
const _hoisted_2 = { transform: "translate(-870 -642.586)" }
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]
const _hoisted_5 = ["stroke"]

export interface Props {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NextIcon',
  props: {
    color: { default: "#fff" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("line", {
        stroke: _ctx.color,
        class: "a",
        x2: "25",
        transform: "translate(871 654)"
      }, null, 8, _hoisted_3),
      _createElementVNode("line", {
        stroke: _ctx.color,
        class: "a",
        x2: "10",
        y2: "10",
        transform: "translate(887 644)"
      }, null, 8, _hoisted_4),
      _createElementVNode("line", {
        stroke: _ctx.color,
        class: "a",
        x2: "10",
        y2: "10",
        transform: "translate(897 654) rotate(90)"
      }, null, 8, _hoisted_5)
    ])
  ]))
}
}

})